//import "./Polyfill";
export * from "./IHttpService";
export * from "./IHttpRequest";
export * from "./IHttpResponse";
export * from "./IStorageService";
export * from "./IInjector";
export * from "./HttpService";
export * from "./LocalStorageService";
export * from "./Logging";
export * from "./Injector";
export * from "./EventEmitter";